























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("articleCate/add", {
              ...values,
            });

            if (res && res.Message && res.Message === "success") {
              this.$message.success("添加成功");

              this.handleCancel();
            } else {
              this.$message.error("添加失败");
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }
}
